import { Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormComponentControl } from 'src/app/shared/inputs/form-component-control';
import { inputMgsErrs } from 'src/app/validators/message-validation';
import { BuyForType } from 'src/app/models/type/buy-for.type';

@Component({
  selector: 'app-input-buyfor',
  templateUrl: './input-buyfor.component.html',
  styleUrls: ['./input-buyfor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputBuyforComponent),
      multi: true
    }
  ]
})
export class InputBuyforComponent extends FormComponentControl implements OnInit {
  errors = inputMgsErrs.insuranceBuyFor;
  private _isDisabled;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer
  ) {
    super(cc);
  }

  get self(): string {
    return BuyForType.Self.toString();
  }

  get family(): string {
    return BuyForType.Family.toString();
  }

  @Input()
  set isDisabled(val: boolean) {
    this._isDisabled = val;
  }

  get isDisabled() {
    return this.control ? (this.control.status === 'DISABLED') || this._isDisabled : this._isDisabled;
  }

  ngOnInit() {
    this.checkInitialControl();
  }

}
